"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.treeSnapshotJobId = exports.treeSnapshotJobPayloadSchema = exports.TREE_SNAPSHOT_STATUS = exports.TREE_SNAPSHOT_QUEUE = void 0;
const zod_1 = require("zod");
/**
 * #714 — the snapshot of the urban-planning rule tree a validated study points at.
 *
 * A validated study used to say nothing about the shape of the questionnaire it
 * had been filled against, which made two studies incomparable the moment the
 * tree moved. A snapshot is that missing reference point, and
 * `urban_analysis.tree_snapshot_id` is the study's foreign key into it — an id,
 * never a hash, so the tree it names can actually be read back.
 *
 * The row is minted **inside the transaction that makes the study VALIDATED**,
 * by a trigger on `urban_analysis`; only the building and storing of its content
 * is deferred to the jobs worker. This module is the contract between the
 * backend (producer) and that worker (consumer), which cannot import from each
 * other.
 */
/** BullMQ queue carrying "settle this snapshot". */
exports.TREE_SNAPSHOT_QUEUE = 'urban_planning_tree_snapshot';
exports.TREE_SNAPSHOT_STATUS = {
    /** Minted at validation; its content has not been built yet. */
    PENDING: 'PENDING',
    /** Content built, and proven to describe the tree the snapshot names. */
    COMPLETE: 'COMPLETE',
    /**
     * The tree moved between the validation and the build, so the content was
     * refused rather than written. The snapshot keeps its identity and says it
     * holds nothing — the study is still tied to a distinct shape of the tree,
     * and nobody is told a tree it never saw is the one it was filled against.
     */
    STALE: 'STALE',
};
/**
 * The job payload.
 *
 * It carries the snapshot's id and nothing else. Not the study's — a snapshot is
 * shared by every study validated against the same shape of the tree, so the
 * snapshot is the unit of work, and `jobId` below makes that sharing collapse
 * into one job instead of one per study.
 */
exports.treeSnapshotJobPayloadSchema = zod_1.z.object({
    snapshotId: zod_1.z.string().uuid(),
});
/**
 * Deterministic BullMQ job id, so two studies sharing a snapshot enqueue once.
 *
 * The separator is a HYPHEN, and must stay one. BullMQ refuses a custom job id
 * containing `:` unless it splits into exactly three parts — the compatibility
 * rule that keeps repeatable-job keys parseable — so `tree-snapshot:<uuid>`
 * throws `Custom Id cannot contain :` at `Queue.add`, before Redis is ever
 * touched. That failure lands on the producer, which runs inside the validating
 * request: every snapshot would stay PENDING for ever, and nothing in the
 * mocked-queue unit tests would notice.
 *
 * A uuid has no colon of its own, so the whole id has none and the rule cannot
 * be tripped by the value either.
 */
const treeSnapshotJobId = (snapshotId) => `tree-snapshot-${snapshotId}`;
exports.treeSnapshotJobId = treeSnapshotJobId;
//# sourceMappingURL=treeSnapshot.js.map